<template>
    <v-container fluid>
        <template v-if="!isInit">
            <v-progress-linear
                indeterminate
            ></v-progress-linear>
        </template>
        <template v-else>
            <h1 class="mt-4">{{ term.termsName }}</h1>

            <v-card flat  color="rgba(0,0,0,0)" class="mt-4 mb-4">
                <v-progress-linear
                    v-if="isLoading"
                    indeterminate
                ></v-progress-linear>
                <template v-else>
                    <v-card flat class="pa-4">
                        <v-card-text v-if="previewContents">
                            <div class="markdown-preview" v-html="previewContents"></div>
                        </v-card-text>
                        <v-card-text v-else>
                            약관을 찾을 수 없습니다.
                        </v-card-text>
                    </v-card>
                </template>
            </v-card>

             <v-footer app
                      fixed
                      outlined
                      class="justify-center elevation-2">
                <v-btn large @click="$router.go(-1)" color="primary">뒤로</v-btn>
            </v-footer>
        </template>
    </v-container>
</template>

<script>
import "@/assets/css/markdown.css";
import {marked} from 'marked'
import TermsMixin from "@/pages/home/views/apply/TermsMixin";

// Set options
marked.use({
  async: true,
  pedantic: false,
  gfm: true,
});

export default {
    name: 'TermViewer',
    mixins: [TermsMixin],

    data: () => ({
        isInit: false,
        isLoading: false,
        marked: marked,
        termsId: null,
        term: null,
        privacyPolicy: null,
        previewContents: null,
    }),

    async created() {
        this.termsId = this.$route.params.termsId;
        await this.fetchTerm(this.termsId);
    },

    methods: {
        async fetchTerm() {
            this.isLoading = true;
            try {
                this.term = await this.findTerm(this.termsId)
                if (this.term?.contents) {
                    this.previewContents = await marked.parse(this.term.contents);
                }
            } catch(err) {
                console.error(err);
            } finally {
                this.isLoading = false;
                this.isInit = true;
            }
        }
    }


}
</script>

<style scoped>
h1 {
    font-size: 2rem;
}
</style>